export default __webpack_public_path__ + "static/media/news2img6.9c17580a.png";